namespace $.$$ {

	$mol_style_define( $shm_tests_visual, {

		flex: {
			direction: 'column',
		},
		gap: $mol_gap.text,
		width: '100%',
		padding: $mol_gap.block,
		border: {
			width: '1px',
			style: 'solid',
			color: $mol_theme.line,
			radius: $mol_gap.round,
		},

		Head: {
			align: {
				items: 'baseline',
			},
			gap: $mol_gap.block,
		},

		Title: {
			font: {
				weight: 'bold',
			},
		},

		Status: {
			color: $mol_theme.current,
		},

		Metrics: {
			color: $mol_theme.shade,
		},

		Images: {
			flex: {
				wrap: 'wrap',
			},
			gap: $mol_gap.block,
			align: {
				items: 'flex-start',
			},
		},

		Image: {
			flex: {
				direction: 'column',
				grow: 1,
				basis: '18rem',
			},
			minWidth: 0,
			gap: $mol_gap.text,
			color: $mol_theme.text,
			textDecoration: 'none',
		},

		Image_label: {
			font: {
				weight: 'bold',
			},
		},

		Picture: {
			width: '100%',
			minWidth: 0,
			maxWidth: '100%',
			maxHeight: '32rem',
			objectFit: 'contain',
		},

	} )

}
